import React, { lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import * as LoaderSpinner from 'react-loader-spinner';
import { SideNav } from "components";
import "react-responsive-carousel/lib/styles/carousel.min.css";


const Home = lazy(() => import('pages').then(({ Home }) => ({ default: Home })));
const Offers = lazy(() => import('pages').then(({ Offers }) => ({ default: Offers })));
const PitonsBank = lazy(() => import('pages').then(({ PitonsBank }) => ({ default: PitonsBank })));
const UserRegister = lazy(() => import('pages').then(({ UserRegister }) => ({ default: UserRegister })));
const JoinUs = lazy(() => import('pages').then(({ JoinUs }) => ({ default: JoinUs })));
const SignUp = lazy(() => import('pages').then(({ SignUp }) => ({ default: SignUp })));
const SignIn = lazy(() => import('pages').then(({ SignIn }) => ({ default: SignIn })));
const RecoverPassword = lazy(() => import('pages').then(({ RecoverPassword }) => ({ default: RecoverPassword })));
const BlogueChronic = lazy(() => import('pages').then(({ BlogueChronic }) => ({ default: BlogueChronic })));
const MySpaceHome = lazy(() => import('pages').then(({ MySpaceHome }) => ({ default: MySpaceHome })));
const RegistrationAppointment = lazy(() => import('pages').then(({ RegistrationAppointment }) => ({ default: RegistrationAppointment })));
const NotFound = lazy(() => import('pages').then(({ NotFound }) => ({ default: NotFound })));
//const ResetPassword = lazy(() => import('pages').then(({ ResetPassword }) => ({ default: ResetPassword })));
const RecoverPublicPassword = lazy(() => import('pages').then(({ RecoverPublicPassword }) => ({ default: RecoverPublicPassword })));

function App() {
    return (
        <React.Fragment>
            <Router>
                <SideNav />
                <React.Suspense fallback={
                    <div style={{
                        textAlign: "center",
                        width: "100%",
                        marginTop: "8%"
                    }}>
                        <LoaderSpinner.Hourglass
                            //color="#76bd1d"
                            height={100}
                            width={100}
                        />
                    </div>}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/offers" element={<Offers />} />
                        <Route path="/pitons.bank" element={<PitonsBank />} />
                        <Route path="/blogue.chronics" element={<BlogueChronic />} />
                        <Route path="/register/user" element={<UserRegister />} />
                        <Route path="/joinus" element={<JoinUs />} />
                        <Route path="/sign_up" element={<SignUp />} />
                        <Route path="/sign_in" element={<SignIn />} />
                        <Route path="/sign_up/appointment/:token" element={<RegistrationAppointment />} />
                        <Route path="/password.recovery" element={<RecoverPassword />} />
                        <Route path="/password.recovery/:token" element={<RecoverPublicPassword />} />
                        <Route path="/space/*" element={<MySpaceHome />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </React.Suspense>
            </Router>
        </React.Fragment>
    );
}

export default App;
